module.exports = __webpack_public_path__ + "static/img/city-profile.3b3fb65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/city-profile.jpg
// module id = IIYn
// module chunks = 1